import styled from "styled-components";
import { rem } from "../../../helpers/rem/px-to-rem";

export const STT = styled.div`
  width: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
export const TableExportWrapper = styled.div`
  .quarter {
    color: #0089cf;
    font-weight: 700;
    font-size: 20px;
    width: 100%;
    margin: ${rem(8)} 0;
    text-align: end;
  }
  .header-table {
    display: flex;
    flex-direction: row;
    width: 100%;
    font-weight: 600;
    background-color: #0089cf;
    color: #fff;
    font-size: 1.1rem;
    .content {
      display: flex;
      align-items: center;
      width: 30%;
      padding: 0 ${rem(5)};
      text-align: center;
    }
    .criteria {
      display: flex;
      align-items: center;
      width: 50%;
      padding: 0 ${rem(5)};
      text-align: center;
    }
    .achieve {
      display: flex;
      align-items: center;
      width: 20%;
      padding: 2px ${rem(5)};
      text-align: center;
      line-height: 20px;
    }
  }
  .body-table {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-top: none;
    min-height: 85px;
    border-bottom: 1px solid #bdc3c7;
    .content {
      width: 30%;
      padding: ${rem(6)};
      font-weight: 500;
    }
    .criteria {
      width: 50%;
      padding: ${rem(6)};
    }
    .achieve {
      width: 20%;
      padding: ${rem(6)};
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .summary-table {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-top: none;
    font-weight: 600;
    background-color: gray;
    color: #fff;
    .content {
      width: 35%;
      padding: ${rem(5)};
      align-items: center;
    }
    .criteria {
      width: 50%;
      padding: ${rem(5)};
      font-style: italic;
    }
    .achieve {
      width: 20%;
      padding: ${rem(5)};
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
